import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Component, inject } from '@angular/core';
import { MaintenanceService } from '@riise/core/services/maintenance/maintenance.service';


@Component({
  selector: 'app-maintenance',
    imports: [
        TranslateModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        NgSelectModule,
        NgScrollbarModule,
        NgbModule
    ],
    templateUrl: './maintenance.component.html',
    styleUrl: './maintenance.component.scss'
})
export class MaintenanceComponent {
  private maintenanceService = inject(MaintenanceService);
  type: 'offline' | 'maintenance' = 'offline';

  constructor() {
    this.maintenanceService.maintenanceType$.subscribe(type => {
      this.type = type;
    });
  }

  reloadPage() {
      window.location.reload();
  }
}
